export enum DeviceName {
    WATER_ROWER = 'water_rower',
    WALL = 'wall',
    SLIMBEAM = 'slimbeam',
    WORKX = 'workx',
    SWING = 'swing',
    TRIA_TRAINER = 'tria_trainer',
    SLIMBEAM_BENCH = 'bench',
    WATER_GRINDER = 'water_grinder',
    WALL_BARS = 'wall_bars',
    WEIGHT_BENCH = 'weight_bench',
    SLING = 'sling',
    YAFI = 'yafi',
    HANDLE_BARS = 'handle_bars', //Slimbeam rope
    ROPE = 'rope', //Slimbeam rope
    LAT_BAR = 'lat_bar',
    ANKLE_STRAP = 'ankle_strap',
    PULL_UP_BAR = 'pull_up_bar',
    WALL_BARS_BENCH = 'wall_bars_bench',
    COMBI_TRAINER = 'combi_trainer',
    MULTI_ADAPTER = 'multi_adapter',
    BIKE = 'bike',
    SPRINTBOK = 'sprintbok',
    ELASKO = 'elasko',
    FLOW_ROW = 'flow_row',
    EAU_ME_BOARD = 'eau_me_board',
}

export function listDevices(): Array<{id: DeviceName; name: string}> {
    return Object.values(DeviceName).map((deviceName) => {
        return {
            id: deviceName,
            name: toHumanReadableDeviceName(deviceName),
        };
    });
}

export function toHumanReadableDeviceName(deviceName: DeviceName): string {
    switch (deviceName) {
        case DeviceName.WATER_ROWER:
            return 'WaterRower';
        case DeviceName.WALL:
            return 'Wall';
        case DeviceName.SLIMBEAM:
            return 'Slimbeam';
        case DeviceName.WORKX:
            return 'WeightWorkx';
        case DeviceName.SWING:
            return 'SwingBells';
        case DeviceName.TRIA_TRAINER:
            return 'TriaTraining';
        case DeviceName.SLIMBEAM_BENCH:
            return 'Bench (for Slimbeam)';
        case DeviceName.WATER_GRINDER:
            return 'WaterGrinder';
        case DeviceName.WALL_BARS:
            return 'WallBars';
        case DeviceName.WEIGHT_BENCH:
            return 'WeightBench';
        case DeviceName.SLING:
            return 'Sling';
        case DeviceName.YAFI:
            return "Ya'fi";
        case DeviceName.HANDLE_BARS:
            return 'HandleBars';
        case DeviceName.ROPE:
            return 'Rope';
        case DeviceName.LAT_BAR:
            return 'LatBar';
        case DeviceName.ANKLE_STRAP:
            return 'AnkleStrap';
        case DeviceName.PULL_UP_BAR:
            return 'PullUpBar';
        case DeviceName.WALL_BARS_BENCH:
            return 'Bench (for WallBars) ';
        case DeviceName.COMBI_TRAINER:
            return 'CombiTrainer';
        case DeviceName.MULTI_ADAPTER:
            return 'MultiAdapter';
        case DeviceName.BIKE:
            return 'Bike';
        case DeviceName.SPRINTBOK:
            return 'Sprintbok';
        case DeviceName.ELASKO:
            return 'Elasko';
        case DeviceName.FLOW_ROW:
            return 'FlowRow';
        case DeviceName.EAU_ME_BOARD:
            return 'Eau Me Board';
    }
}
